import { Button, Modal } from "antd";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

export const SModal = styled(Modal)`
  &.ant-modal {
    background: rgba(5, 10, 31, 0.96);
    border: 1px solid rgba(0, 240, 255, 0.2);
    border-radius: 16px;
    padding-bottom: 0;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45) !important;
    backdrop-filter: blur(20px);

    .ant-modal-content {
      background: transparent !important;
      box-shadow: none !important;
      color: #fff;
    }

    .ant-modal-body p {
      color: #a0aec0;
    }
  }
`;

const StyledModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
  confirmText,
  title,
  label
}: any) => {
  return (
    <SModal
      centered
      open={isOpen}
      onOk={onClose}
      onCancel={onClose}
      mask={false}
      closable={false}
      footer={
        <div className="flex flex-row gap-[12px] mt-[32px] w-full">
          <Button
            size="large"
            key="back"
            onClick={onClose}
            style={{ width: "80%" }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            size="large"
            danger
            onClick={onConfirm}
            style={{ width: "80%" }}
            loading={loading}
          >
            {confirmText ?? "Delete"}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center text-center gap-6">
        <FontAwesomeIcon
          icon={faCircleExclamation}
          color="#ff6969"
          className="h-[6rem]"
        />
        <p className="text-2xl font-bold">{title ?? "Are you sure?"}</p>
        <p className="text-xl font-normal">{label ?? "You wont be able to revert this!"}</p>
      </div>
    </SModal>
  );
};

export default StyledModal;
